import { EmptyState, type EmptyStateKind } from "./EmptyState";

export interface AdMetric {
  label: string;
  value: string;
  sub?: string;
}

interface AdsBlockProps {
  title: string;
  /** 'live' disindaki her sey EmptyState'e duser (not_connected/not_supported/error). */
  status: string;
  reason?: string | null;
  /** `status === 'error'` iken backend'in KENDI hata metni (ör. gidisat.py
   * pazarlama.hata/trafik.hata) — inceleme bulgusu: eskiden 'error' durumu
   * 'not_connected' govdesine ("Bağlı değil") DUSUYORDU, gercek hata
   * kayboluyordu; kullanici baglantinin hic kurulmadigini mi yoksa var olan
   * baglantinin mi hata verdigini AYIRT EDEMIYORDU. */
  errorMessage?: string | null;
  metrics?: AdMetric[];
  setupHref?: string;
  note?: string;
}

/**
 * Reklam platformu bloğu (Meta/Google) — docs/faz5-arayuz-spec.md §3.
 * `status !== 'live'` → EmptyState: not_connected (kurulum linki), not_supported
 * (platform-yok mesaji), error (baglanti VAR ama son cekim basarisiz —
 * `errorMessage` DOGRUDAN gosterilir, 'not_connected' ile KARISTIRILMAZ).
 */
export function AdsBlock({ title, status, reason, errorMessage, metrics = [], setupHref, note }: AdsBlockProps) {
  const isLive = status === "live";
  // Sozlesme: not_supported kart SAYFA seviyesinde gizlenir (tasarim rehberi §2).
  if (status === "not_supported") return null;
  const emptyKind: EmptyStateKind =
    status === "no_data" ? "no_data" : status === "error" ? "error" : "not_connected";

  return (
    <div className="card" data-testid="ads-block" data-status={status}>
      <h3 className="mb-3 font-display text-[15px] font-bold text-ink">{title}</h3>
      {isLive ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {metrics.map((m) => (
            <div key={m.label} className="space-y-0.5">
              <div className="text-xs text-muted">{m.label}</div>
              <div className="num text-lg font-bold text-ink">{m.value}</div>
              {m.sub && <div className="text-[11px] text-muted">{m.sub}</div>}
            </div>
          ))}
        </div>
      ) : (
        <EmptyState
          kind={emptyKind}
          reason={reason}
          message={status === "error" ? errorMessage : undefined}
          setupHref={status === "not_connected" ? setupHref : undefined}
        />
      )}
      {note && isLive && <p className="mt-3 text-xs text-muted">{note}</p>}
    </div>
  );
}
